export default __webpack_public_path__ + "static/media/exam_overview_desktop.5fbe45b0.jpg";